import { useState, useEffect } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { user, login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => { if (user && user !== false) navigate("/"); }, [user, navigate]);
  if (user && user !== false) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) navigate("/");
  };

  return (
    <div className="min-h-screen auth-bg flex items-center justify-center px-6">
      <div className="max-w-md w-full">
        <div className="mb-10 text-center">
          <div className="label-eyebrow">Gestionale · Orosei</div>
          <img src="/logo-carasau-dark.png" alt="Carasau Café" className="w-56 h-auto mx-auto mt-4" />
          <p className="mt-6 text-neutral-600 max-w-sm mx-auto">Il centro operativo del tuo locale. Finanze, magazzino, personale, decisioni in un'unica piattaforma.</p>
        </div>
        <form onSubmit={onSubmit} className="bg-white border border-[#E2D9C8] rounded-lg p-8 space-y-5">
          <div>
            <Label className="label-eyebrow" htmlFor="email">Email</Label>
            <Input data-testid="login-email" id="email" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} className="mt-2" placeholder="tu@carasau.it" />
          </div>
          <div>
            <Label className="label-eyebrow" htmlFor="password">Password</Label>
            <Input data-testid="login-password" id="password" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)} className="mt-2" />
          </div>
          {error && <div data-testid="login-error" className="text-sm text-red-700">{error}</div>}
          <Button data-testid="login-submit" type="submit" disabled={loading}
            className="w-full bg-neutral-900 hover:bg-neutral-800 text-[#FDFBF7] rounded-md">
            {loading ? "Accesso…" : "Entra"}
          </Button>
        </form>
      </div>
    </div>
  );
}
